/* global window */
'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports['default'] = chromeDebug;

function chromeDebug(alt) {
  if (typeof window !== 'undefined') window['alt.js.org'] = alt;
  return alt;
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/alt-utils/lib/chromeDebug.js
// module id = 1338
// module chunks = 0 1